<template>
  <b-form-group
    label="Enter Snowflake details:"
    label-cols="3"
    label-size="lg"
    :disabled="loading"
  >
    <b-form-group
      label="Account:"
      label-cols="3"
      placeholder="xy12345.ap-southeast-2"
    >
      <template v-slot:description>
        Do not include the Snowflake domain name (snowflakecomputing.com) <b-link href="https://docs.snowflake.com/en/user-guide/python-connector-api.html#usage-notes-for-the-account-parameter-for-the-connect-method">
          Read more
        </b-link>
      </template>
      <b-input
        :value="account"
        :state="getState(v.snowflakeSource.account)"
        @input="updateProp('account', $event)"
      />
    </b-form-group>

    <b-form-group
      label="Username:"
      label-cols="3"
      description="The user needs read access to the table or view"
    >
      <b-input
        :value="username"
        :state="getState(v.snowflakeSource.username)"
        @input="updateProp('username', $event)"
      />
    </b-form-group>

    <b-form-group
      label="Password:"
      label-cols="3"
    >
      <b-input
        :value="password"
        type="password"
        :state="getState(v.snowflakeSource.password)"
        @input="updateProp('password', $event)"
      />
    </b-form-group>

    <b-form-group
      label="Warehouse:"
      label-cols="3"
      description="Optional if user has default warehouse"
    >
      <b-input
        :value="warehouse"
        @input="updateProp('warehouse', $event)"
      />
    </b-form-group>

    <b-form-group
      label="Database name:"
      label-cols="3"
    >
      <SnowflakeDropdownDatabases
        :value="db"
        :state="getState(v.snowflakeSource.db)"
        v-bind="details"
        @input="updateProp('db', $event)"
        @error="$emit('error', $event)"
      />
    </b-form-group>

    <b-form-group
      label="Schema:"
      label-cols="3"
    >
      <SnowflakeDropdownSchemas
        :value="schema"
        :state="getState(v.snowflakeSource.schema)"
        v-bind="details"
        @input="updateProp('schema', $event)"
        @error="$emit('error', $event)"
      />
    </b-form-group>

    <b-form-group
      label="Table or view name:"
      label-cols="3"
    >
      <SnowflakeDropdownTableview
        :value="tableview"
        :state="getState(v.snowflakeSource.tableview)"
        v-bind="details"
        @input="updateProp('tableview', $event)"
        @error="$emit('error', $event)"
      />
    </b-form-group>
    <p
      class="d-flex"
    >
      Your information will be saved upon submitting.
    </p>
  </b-form-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import SnowflakeDropdownDatabases from '@/components/admin/upload/snowflake/SnowflakeDropdownDatabases.vue'
import SnowflakeDropdownSchemas from '@/components/admin/upload/snowflake/SnowflakeDropdownSchemas.vue'
import SnowflakeDropdownTableview from '@/components/admin/upload/snowflake/SnowflakeDropdownTableview.vue'
import { Validation } from 'vuelidate'

const components = {
  SnowflakeDropdownDatabases,
  SnowflakeDropdownSchemas,
  SnowflakeDropdownTableview,
}

const props = {
  loading: Boolean,
  username: {
    type: String,
    default: '',
  },
  password: {
    type: String,
    default: '',
  },
  account: {
    type: String,
    default: '',
  },
  warehouse: {
    type: String,
    default: '',
  },
  db: {
    type: String,
    default: '',
  },
  schema: {
    type: String,
    default: '',
  },
  tableview: {
    type: String,
    default: '',
  },
  v: {
    type: Object,
    required: true,
  },
}

@Component({ components })
export default class SnowflakeDetails extends Vue.extend({ props }) {
  get details () {
    return {
      username: this.username,
      password: this.password,
      account: this.account,
      warehouse: this.warehouse,
      database: this.db,
      schema: this.schema,
      tableview: this.tableview,
    }
  }

  updateProp (propName: string, value: string) {
    this.$emit(`update:${propName}`, value)
  }

  getState (state: Validation) {
    return (state.$dirty ? !state.$error : null) && null
  }
}

</script>
